import {
  downloadPersonnelAdjustmentDocxFile,
  downloadPersonnelAdjustmentPdfFile,
} from 'apis/personnelAdjustment.api';
import { TOAST } from 'constant';
import { toast } from 'layout';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { autoDownloadFile } from 'utils/func';
import PropTypes from 'prop-types';

export default function HeaderInfo({ projectProposalId, isDownload }) {
  const { t } = useTranslation();

  const {
    refetch: handleDownloadPdfFile,
    isLoading: isDownloadPdfFileLoading,
    isFetching: isDownloadPdfFileFetching,
  } = useQuery(
    ['downloadFinancialAdjustmentPdfFile'],
    () => downloadPersonnelAdjustmentPdfFile(projectProposalId),
    {
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      },
    }
  );

  const {
    refetch: handleDownloadDocxFile,
    isLoading: isDownloadDocxFileLoading,
    isFetching: isDownloadDocxFileFetching,
  } = useQuery(
    ['downloadFinancialAdjustmentDocxFile'],
    () => downloadPersonnelAdjustmentDocxFile(projectProposalId),
    {
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportDocxErrorTitle'));
      },
    }
  );
  return (
    <>
      {/* <div className="flex justify-content-between"> */}
      {/* <img src="/logo.png" alt="logo" width="180px" /> */}

      {/* <div className="ml-auto flex flex-column">
          <span>{t('extendImplementationTime.R07.formR07')}</span>
          <span>{t('extendImplementationTime.R07.topicCode')}: ..........</span>
        </div> */}
      {/* </div> */}
      {isDownload && (
        <div className="flex justify-content-end mb-2">
          <Button
            type="button"
            label={t('projectProposal.review.exportDocx')}
            icon={`pi ${
              isDownloadDocxFileLoading || isDownloadDocxFileFetching
                ? 'pi-spin pi-spinner'
                : 'pi-file-word'
            }`}
            className="block w-auto h-3rem mr-4"
            severity="info"
            onClick={handleDownloadDocxFile}
            disabled={!projectProposalId || isDownloadDocxFileLoading || isDownloadDocxFileFetching}
          />
          <Button
            type="button"
            label={t('projectProposal.review.exportPdf')}
            icon={`pi ${
              isDownloadPdfFileLoading || isDownloadPdfFileFetching
                ? 'pi-spin pi-spinner'
                : 'pi-file-pdf'
            }`}
            className="block w-auto h-3rem border-none"
            style={{ backgroundColor: 'var(--red-400)' }}
            onClick={handleDownloadPdfFile}
            disabled={!projectProposalId || isDownloadPdfFileLoading || isDownloadPdfFileFetching}
          />
        </div>
      )}

      <h3 className="mb-5 line-height-3 text-3xl text-center font-bold">
        {t('editHumanResource.header.title')}
        <br />
        <span className="font-normal text-xl">{t('editHumanResource.header.subTitle')}</span>
      </h3>
    </>
  );
}

HeaderInfo.propTypes = {
  projectProposalId: PropTypes.string.isRequired,
  isDownload: PropTypes.bool.isRequired,
};
